import { faListUl } from '@fortawesome/pro-regular-svg-icons'
import { SectionWrapper } from '../../../common/components/SectionWrapper/SectionWrapper'
import {
  DetailInfo,
  DetailRow,
} from '../../../common/components/DetailRow/DetailRow'
import { useStyles } from './Sections.styles'
import { ViewValueWithTruncate } from '@labrav/common'
import { MsftCombinedFormState } from '../../../modules/microsoftCombinedForm/reducer'
import { formatMonthYear } from '../../../common/utils/dateAndTimeConversion'
import { useSelector } from '../../../store'

export const PurchaseTerms = ({
  microsoftCombinedFormDetails,
}: {
  microsoftCombinedFormDetails?: MsftCombinedFormState
}) => {
  const { classes } = useStyles()

  const isVariableStartDate =
    microsoftCombinedFormDetails?.draftOffer?.variableStartDate

  const timeZone = useSelector<string>(
    state =>
      state.userProfile.userProfile.timeZone ||
      state.userProfile.userProfile.defaultTimeZone ||
      'UTC'
  )
  return (
    <div>
      <SectionWrapper heading="Purchase terms" icon={faListUl} varient="small">
        <div className={classes.sectionContent}>
          <DetailRow borderBottom>
            <>
              <DetailInfo
                title="Purchase start date"
                value={
                  <ViewValueWithTruncate
                    value={
                      isVariableStartDate ? 'Accepted date' : 'Specified month'
                    }
                  />
                }
                keyName="offerStartDate"
              />
              {!isVariableStartDate && (
                <DetailInfo
                  title="Purchase start month"
                  value={
                    microsoftCombinedFormDetails?.draftOffer?.offerStartDate
                      ? (() => {
                          const { month, year } = formatMonthYear(
                            microsoftCombinedFormDetails?.draftOffer
                              ?.offerStartDate,
                            timeZone
                          )
                          return (
                            <div className={classes.createdAtDate}>
                              {month}, {year}
                            </div>
                          )
                        })()
                      : '-'
                  }
                  keyName="offerStartDate"
                />
              )}
            </>
          </DetailRow>
          <DetailRow borderBottom>
            <>
              <DetailInfo
                title="Purchase end month"
                value={
                  microsoftCombinedFormDetails?.draftOffer?.offerExpirationDate
                    ? (() => {
                        const { month, year } = formatMonthYear(
                          microsoftCombinedFormDetails?.draftOffer
                            ?.offerExpirationDate,
                          timeZone
                        )
                        return (
                          <div className={classes.dateTimeWrapper}>
                            <div className={classes.createdAtDate}>
                              {month}, {year}
                            </div>
                          </div>
                        )
                      })()
                    : '-'
                }
                keyName="offerExpirationDate"
              />
            </>
          </DetailRow>
        </div>
      </SectionWrapper>
    </div>
  )
}
